class SubscriptionFlyout {
    init() {
        this.initSubscriptionFlyout();
    }

    initSubscriptionFlyout() {
        let content = document.querySelector('.subscription-flyout');
        let loginDropDown = document.querySelector('.login-dropdown');
        let currentPage = window.location.pathname;

        if (content) {
            let header = document.querySelector('.header');

            let railTrigger = content.querySelector('.subscription-flyout-rail');
            let close = content.querySelector('.subscription-flyout-close');

            const setPosition = () => {
                let headerHeight = header.offsetHeight;

                if (window.innerWidth < 992) {
                    //document.querySelector('main').style.paddingTop = `${content.offsetHeight}px`;
                    let visible = headerHeight + header.getBoundingClientRect().y;
                    visible = visible > 0 ? visible : 0;
                    //content.style.top = `${visible}px`;
                } else {
                    document.querySelector('main').style.paddingTop = 'unset';
                    content.style.top = `${headerHeight + 32}px`;
                }
            };

            railTrigger.onclick = () => {
                content.classList.add('is-expanded');
                loginDropDown.classList.remove('active');
            };

            close.onclick = () => {
                content.classList.remove('is-expanded');
            };

            window.addEventListener('resize', () => {
                setPosition();
            });

            window.addEventListener('scroll', () => {
                setPosition();
            });

            setPosition();
        }
    }
}

export default SubscriptionFlyout;

(() => {
    const subscriptionFlyout = new SubscriptionFlyout();
    subscriptionFlyout.init();
})();
